import React from "react";
import { PageHeader, Button, Icon, Col, Row } from "antd";


export default function Header(props) {
  return (
    <PageHeader
      title={
        <div>
          <Icon type="container" />
          &nbsp;&nbsp;<span>{props.title}</span>
        </div>
      }
      style={{ overflowX: 'auto' }}
      extra={[

        <div style={{ width: '100%', textAlign: "right" }}>
          <div key="1" className="custom-options" sm={24} md={12} lg={4}>

            <Button
              icon="setting"
              type="success"
              loading={props.loadingEdit}
              onClick={props.onEdit}
            >
              Configurar
            </Button>

            {props.onNew === undefined ? null : (
              <Button
                icon="plus"
                type="primary"
                loading={props.loadingNew}
                onClick={props.onNew}
              >
                Nuevo
              </Button>
            )}

            {props.onSearch === undefined ? null : (
              <Button icon="search" type="primary" ghost onClick={props.onSearch} >
                Buscar
              </Button>
            )}

            {props.onClearFilters === undefined ? null : (
              <Button icon="shake" type="primary" ghost onClick={props.onClearFilters} >
                Limpiar
              </Button>
            )}
          </div>
        </div>,
      ]}
    ></PageHeader>
  );
}
